module.exports = __webpack_public_path__ + "img/wandr-e-logo-big.5e020965.svg";